import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type StudyInfo = {
    StudyOrg: string;
    StudyName: string;
};

// Helper function to get query parameters from the URL
const getQueryParams = (): StudyInfo => {
    const params = new URLSearchParams(window.location.search);
    return {
        StudyOrg: params.get('StudyOrg') || "Loading Studies...",
        StudyName: params.get('StudyName') || "",
    };
    // Need to write code here to check if the studyOrg and studyName is assigned to the particular User
    // Should show error when it is not assigned
    // This is the case if the user is logging in through URL having query strings.
};

// Initialize study with query parameters
const initStudy: StudyInfo = getQueryParams();

export const studySlice = createSlice({
    name: 'studyInfo',
    initialState: { study: initStudy },
    reducers: {
        updateStudyOrg: (state, action: PayloadAction<string>) => {
            state.study.StudyOrg = action.payload;
        },
        updateStudyName: (state, action: PayloadAction<string>) => {
            state.study.StudyName = action.payload;
        },
        updateStudyInfo: (state, action: PayloadAction<StudyInfo>) => {
            state.study = action.payload;
        },
    },
});

export const { updateStudyOrg, updateStudyName, updateStudyInfo } = studySlice.actions;

export default studySlice.reducer;
